import React from 'react';
import { LanguageIndicatorChip } from 'Components/LanguageIndicatorChip';

export const getTableHeader = (t, viewerLang) => [
  {
    id: 'date',
    type: 'datebr',
    value: 'Data',
  },
  {
    id: 'time',
    type: 'text',
    value: 'Hora',
  },
  {
    id: 'user',
    type: 'text',
    value: 'Usuário',
  },
  {
    id: 'action',
    type: 'text',
    value: 'Ação',
    render: (action, item) => {
      let payload = {};
      if (item.dataAfterAction) {
        try {
          payload = JSON.parse(item.dataAfterAction) ?? {};
        } catch {
          // Corrupt legacy payload — render without interpolation rather than break the table
          payload = {};
        }
      }
      const label = action?.startsWith('audit:') ? t(action, payload) : (action ?? '');
      const showChip = item.language && item.language !== viewerLang;
      return (
        <span style={{ display: 'inline-flex', alignItems: 'center' }}>
          {label}
          {showChip && <LanguageIndicatorChip language={item.language} />}
        </span>
      );
    },
  },
  {
    id: 'return',
    type: 'text',
    value: 'Resposta',
  },
];
